import { useTranslation } from 'react-i18next';

import { mapComponentRegionToKey } from '../../enums/component-region';
import { IComponent } from '../../interfaces/IComponent';

type ComponentRegionProps = {
  component: IComponent;
};

const firstLetterUppercase = (value: string): string => {
  if (!value) return '';

  return value.charAt(0).toUpperCase() + value.slice(1);
};

const ComponentRegion = ({ component }: ComponentRegionProps) => {
  const { t } = useTranslation();

  if (component.country) {
    return firstLetterUppercase(component.country);
  }

  if (!component.region) return;

  if (mapComponentRegionToKey(component.region) !== '') {
    return t(`componentsPage.regionNames.${mapComponentRegionToKey(component.region)}`);
  }

  return firstLetterUppercase(component.region);
};

export default ComponentRegion;
